module.exports = __webpack_public_path__ + "static/tone-logo-1e0601d1fabc40cb1dac9062f7d7ca21.png";